import { Item } from "@/types";
import { atom } from "jotai";

const itemsAtom = atom<Item[]>([])

export default itemsAtom
